import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../icons/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-6cc3ea9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-info" }
const _hoisted_2 = { class: "file-size" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { ref } from "vue";
import store from "@/store";
import { UploadableFile } from "@/classes/UploadableFile";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilePreview',
  props: {
    file: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
  // file: { type: Object, required: true },
  // tag: { type: String, default: "li" },
  // showThumbnail: {
  //   type: Boolean,
  //   required: true,
  // },
  file: UploadableFile;
  index: number;
}



const deleteFile = () => {
  store.commit("deleteFile", props.index);
};

const display_btn = ref(false);

const displayButton = () => {
  display_btn.value = true;
};

const hideButton = () => {
  display_btn.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onMouseenter: displayButton,
    onMouseleave: hideButton,
    class: "single-file"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(__props.file.filename), 1),
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.file.size), 1)
    ]),
    _withDirectives(_createElementVNode("div", {
      onClick: deleteFile,
      class: "delete-btn"
    }, _hoisted_4, 512), [
      [_vShow, display_btn.value]
    ])
  ], 32))
}
}

})